import { SessionService } from './../../service/session.service';

import { CandidateModel } from './../../model/candidate';
import { Component, OnInit, Output, EventEmitter, Input, Pipe, ViewChild, AfterViewInit, ElementRef  } from '@angular/core';
import { FormControl, FormGroup, } from '@angular/forms';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { SidebarService } from '../../service/sidebar.service';
import { Constants } from '../../constant';
import { Title, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss']
})


export class LandingComponent implements OnInit, AfterViewInit  {

  @Output() votedEvent = new EventEmitter<any>();
  @Input() sideBarShow: boolean;
  mobile: boolean;
  model: any;
  candidates: CandidateModel[];
  electionModel: any;

  contests: any = [];
  currentPage: string = '';
  candidate: any;

  landingPageFormGroup = new FormGroup({
    LandingPageTitle: new FormControl(),
    LandingPageMessage: new FormControl(),
    ElectionId: new FormControl(),
    ElectionName: new FormControl(),

    BallotData: new FormControl()
  });

  readonly CONSTANTS = Constants;
  viewPage = '';
  voters: any = [];
  error: string = '';
  selectedVoters: number = 0;
  totalCompleted: number = 0;
  @ViewChild('landtitle') landtitle: ElementRef;
  constructor(
    private router: Router,
    public route: ActivatedRoute,
    private sessionService: SessionService,
    private titleService: Title) {
    
    
    

    this.electionModel = JSON.parse((<any>document.getElementById('model')).value);
    this.titleService.setTitle("Welcome - 2026 CAPE Contract Ratification");

    this.model = {
      contestDto: [{
        Id: Number,
        BallotTypeId: Number,
        Title: String,
        MaxVotes: Number,
        VotesCast: Boolean,
        SortOrder: Number
      }],
      TotalContests: Number
    };

    this.candidates = [];
    this.landingPageFormGroup.patchValue(this.model);
    this.viewPage = this.CONSTANTS.START_VOTING_PAGE;
  }

  ngOnInit() {
    this.route.data.subscribe((response: { InitialData: any }) => {
      var result = response.InitialData;
      this.sessionService.putSessionValue(this.CONSTANTS.CANDIDATE_KEY, JSON.stringify(result));
      this.candidates = result;
    });
    if (window.innerWidth < 825) {
      this.mobile = true;
    }
  }

  ngAfterViewInit() {
    //setTimeout(() => this.setFocus(), 0);
  }

  startVoting() {
    this.router.navigate(['/voting']);
  }
  setFocus() {
    this.landtitle.nativeElement.focus();
  }
}



// WEBPACK FOOTER //
// ./src/app/features/landing/landing.component.ts